import React from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/components'
import { WarehouseRevisionsStore } from 'store/warehouse-revisions.store'

export const StartRevisionFeature = observer(() => {
  const { startRevision } = WarehouseRevisionsStore
  return <Button onClick={startRevision}>Start Revision</Button>
})
